import { Component, inject, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { TourService } from 'ngx-ui-tour-md-menu';
import { ETourRef, IstepOptionCustom } from './tour-step-option';
import { TourStepsService } from 'src/app/services/tour-steps.service';
import { ApiUsuarioService } from 'src/app/services/api-usuario.service';
import { HttpErrorResponse } from '@angular/common/http';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroXMark } from '@ng-icons/heroicons/outline';
import { GaEventModule } from 'src/app/directives/ga-event/ga-event.module';

@Component({
  selector: 'app-tour-step',
  standalone: true,
  imports: [NgIcon, NgClass, GaEventModule],
  providers: [provideIcons({heroXMark})],
  templateUrl: './tour-step.component.html',
  styleUrl: './tour-step.component.scss'
})
export class TourStepComponent {
  protected tourService = inject(TourService);
  private tourStepsService = inject(TourStepsService);
  private apiUsuario = inject(ApiUsuarioService);

  @Input() step!: IstepOptionCustom;
  
  protected closeTour = () => {
    this.tourService.end();
    this.tourStepsService.currentAnchor.set('');
  }
  
  protected confirmAction = (tourRef: ETourRef) => {   
    let partialPrefs: any = {};

    switch(tourRef) {
      case ETourRef.MENU:
        partialPrefs.menuStepCompleted = true;
        break;
      case ETourRef.SEND_QUOTE:
        partialPrefs.sendQuoteStepCompleted = true;
        break;
      default:
        partialPrefs.tourCompleted = true;
    }
   
    this.tourService.end();
    this.tourStepsService.resetTour();
    
    this.apiUsuario.salvarConfigs(partialPrefs).subscribe({
      error: (error: HttpErrorResponse) => {
        console.log("Erro ao salvar preferencias de usuario ", error);
      }
    });
  }
}
